import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PromocodeBanner } from '@features/promocode-banner/types';

@Component({
  selector: 'anz-promocode-banner',
  styleUrls: ['./promocode-banner-ui.component.scss'],
  template: `
    <div class="container flex flex-col rounded-[4px] bg-[#EEF2F6] lg:flex-row">
      <img
        class="hidden rounded-bl-[4px] rounded-tl-[4px] lg:block"
        src="{{ promocodeBanner.desktopImageUrl }}"
        alt="" />
      <img
        class="block rounded-tl-[4px] rounded-tr-[4px] lg:hidden"
        src="{{ promocodeBanner.mobileImageUrl }}"
        alt="" />
      <div
        class="text-content flex flex-col justify-between px-4 py-5 lg:py-6 lg:pl-[32px] lg:pr-[55px]">
        <h2
          class="m-0 text-[1.25rem] text-[#004165] md:text-[1.5rem]"
          tabindex="0">
          {{ promocodeBanner.title }}
        </h2>
        <markdown class="markdown" [data]="promocodeBanner.subtitle">
        </markdown>
        <div class="mt-auto">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnzPromocodeBannerComponent {
  @Input() promocodeBanner: PromocodeBanner;
}
